export const COUNTER_DOCUMENT_IDS = {
  EXERCISES: 'exercises',
  TARGET_AREA: 'targetArea',
  WORKOUTS: 'workouts',
} as const;

export const COUNTER_FIELDS = {
  COUNT: 'count',
} as const;
